import { render, staticRenderFns } from "./LevelSelection.vue?vue&type=template&id=16016dbd&scoped=true"
import script from "./LevelSelection.vue?vue&type=script&lang=js"
export * from "./LevelSelection.vue?vue&type=script&lang=js"
import style0 from "./LevelSelection.vue?vue&type=style&index=0&id=16016dbd&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16016dbd",
  null
  
)

export default component.exports